import { render, staticRenderFns } from "./publishElement.vue?vue&type=template&id=38cba754"
import script from "./publishElement.vue?vue&type=script&lang=js"
export * from "./publishElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports